import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { BehaviorSubject } from 'rxjs';
import { OffCanvasMenuBodyComponent } from './off-canvas-menu-body.component';
@Component({
    selector: 'off-canvas-menu',
    templateUrl: './off-canvas-menu.component.html',
    styleUrls: ['./off-canvas-menu.component.scss'],
    standalone: true,
    imports: [OffClickModule, OffCanvasMenuBodyComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OffCanvasMenuComponent {
    @Input()
    offCanvasState!: BehaviorSubject<boolean>;

    constructor(private router: Router) {
        this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.close();
            }
        });
    }

    close() {
        this.offCanvasState.next(false);
    }
}
